var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.image},[(!_vm.isSideImage)?_c('img',{staticClass:"e-image",style:(_vm.component.styling),attrs:{"src":_vm.component.content.url}}):_c('div',{class:_vm.$style.sideImage,style:({ backgroundImage: `url('${_vm.component.content.url}')`,
                 backgroundPosition: _vm.component.styling.backgroundPosition,
                 backgroundSize: _vm.component.styling.backgroundSize,
                 backgroundColor: _vm.component.styling.backgroundColor })}),(_vm.isTarget)?_c('div',{class:_vm.$style.shadow}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }